import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LogOut, Layout, MessageSquareQuote, FileText, Users } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

const NAV_ITEMS = [
  { to: "/admin", label: "Dashboard", icon: Layout, end: true },
  { to: "/admin/testimonials", label: "Testimonials", icon: MessageSquareQuote },
  { to: "/admin/blog", label: "Blog Posts", icon: FileText },
  { to: "/admin/leads", label: "Leads", icon: Users }
];

export const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-gray-light flex" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="w-64 bg-gray-dark text-white flex flex-col sticky top-0 h-screen">
        <div className="p-6 border-b border-white/10">
          <Link to="/" className="font-display font-bold text-xl text-white block">FunAsia Admin</Link>
          <p className="text-xs text-gray-300 mt-1">{user?.email}</p>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={`admin-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  isActive ? "bg-orange-primary text-white" : "text-gray-200 hover:bg-white/5"
                }`
              }
            >
              <item.icon size={18} />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <button
          onClick={handleLogout}
          className="m-4 flex items-center justify-center gap-2 bg-white/5 hover:bg-white/10 text-gray-200 px-4 py-3 rounded-lg text-sm transition-colors"
          data-testid="admin-logout-btn"
        >
          <LogOut size={16} /> Sign out
        </button>
      </aside>

      {/* Content */}
      <main className="flex-1 overflow-x-hidden">
        <div className="p-8 max-w-6xl mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
};
